import "./App.css";
import "./antdCustomStyle.scss";
import "video-react/styles/scss/video-react.scss";
import { ConfigProvider, Layout } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { showMessege } from "./components/CustomMessage";
// import Header from "./components/Header";
import Header from "./components/CustomHeader";
import NavigationRoutes from "./routes";
import { ActionCreators, persistor } from "./store";
import { AuthApi } from "./store/api";
import { setToken } from "./store/api/config/AxiosConfig";
import { SQUARE_URL } from "./store/api/config/config";
import { auth } from "./utills/firebase-config";
import Loader from "./components/Loader";
import { signOut } from "firebase/auth";
import googleTagFire from "./utills/googleTagFire";
import "react-phone-input-2/lib/style.css";
import { GlobalDebug } from "./remove_console";
import Cookies from "js-cookie";

const { Content } = Layout;

function App() {
  const containerRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [hideHeader, setHideHeader] = useState(false);
  const { setJwt, setInfo, setLoginLoader } = bindActionCreators(
    ActionCreators,
    dispatch
  );

  const { logOutAction } = bindActionCreators(ActionCreators, dispatch); //call action

  // Prevent iOS Safari scroll-to-top jump at scroll boundaries
  useEffect(() => {
    const preventBoundaryJump = () => {
      const el = document.body;
      if (el.scrollTop === 0) {
        el.scrollTop = 1;
      }
      const atBottom = el.scrollHeight - el.scrollTop === el.clientHeight;
      if (atBottom) {
        el.scrollTop -= 1;
      }
    };
    document.body.addEventListener("touchmove", preventBoundaryJump, { passive: true });
    return () => {
      document.body.removeEventListener("touchmove", preventBoundaryJump);
    };
  }, []);

  useEffect(() => {
    if (location.pathname === "/delete-account") {
      setHideHeader(true);
    } else if (location.pathname.includes("join-zoom")) {
      setHideHeader(true);
    } else if (location.pathname.includes("sign-in")) {
      setHideHeader(true);
    } 
    else if (location.pathname.includes("sign-up")) {
      setHideHeader(true);
    }
    else {
      setHideHeader(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = SQUARE_URL;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    if (
      process.env.NODE_ENV === "production" ||
      process.env.REACT_APP_ENV === "production"
    ) {
      GlobalDebug(false);
    }
  }, []);

  const authHandle = async (user) => {
    const fullName = localStorage.getItem("name");
    const firstName = localStorage.getItem("firstName");
    const lastName = localStorage.getItem("lastName");

    if (user) {
      if (
        user?.email !== null &&
        user?.email !== undefined &&
        user?.email !== ""
      ) {
        setLoginLoader(true);
        const res = await AuthApi.login({
          fire_token: user?.accessToken,
          preferred_name: fullName ?? user?.displayName ?? null,
          first_name: firstName ?? null,
          last_name: lastName ?? null,
        });
        if (res?.status === 200) {
          // localStorage.setItem("token", res?.data?.jwt ?? "");
          Cookies.set("token", res?.data?.jwt);
          setToken(res?.data?.jwt);
          const userData = await AuthApi.userInfo();
          setInfo(userData?.data ?? {});
          localStorage.setItem("name", userData?.data?.name ?? "");
          setJwt(res?.data?.jwt, true);
          setLoading(false);
          setLoginLoader(false);
          googleTagFire("Sign In", null, userData?.data);
        } else {
          setJwt("", false);
          setLoading(false);
          setLoginLoader(false);
          // localStorage.clear();
          setToken(null);
          logOutAction();
          persistor.purge();

          showMessege("error", res?.data?.message);
          const check = res?.response?.data?.message.includes("Inactive");
          if (check) {
            showMessege("error", res?.response?.data?.message);
            signOut(auth);
          }
        }
      } else {
        setJwt("", false);
        setLoading(false);
        showMessege(
          "error",
          "Error! User doesn't have email address! Please try to sign in with different login system."
        );
      }
    } else {
      setJwt("", false);
      setLoading(false);
      // logOutAction();
      console.error("Token has been expired!");
    }
  };

  useEffect(() => {
    const subscriber = auth.onAuthStateChanged(authHandle);
    return subscriber; // unsubscribe on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    containerRef.current.scrollIntoView({ behavior: "smooth" });
  }, [navigate]);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#1BCDB7",
          // fontFamily: archivo?.style?.fontFamily,
        },
      }}
    >
      {/* <Layout style={{ maxHeight: window.innerHeight }}> */}
      <Layout style={{background: "#fff"}}>
        {!hideHeader && <Header />}


        {/* <Layout style={{background: "#fff"}}> */}
          <Content
            ref={containerRef}
            // style={{
            //   height: "88vh",
            //   backgroundColor: "#ffffff",
            //   scrollbarWidth: "none",
            // }}
            className="tw-min-h-[calc(100vh-65px)]"
          >
            {/* <div style={{ textAlign: "center", maxHeight: window.innerHeight }}> */}
            <div className="tw-text-center">
              {loading ? <Loader /> : <NavigationRoutes />}
            </div>
          </Content>
        </Layout>
      {/* </Layout> */}
    </ConfigProvider>
  );
}

export default App;
